import Image from 'next/image';

import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  height: 18rem;

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
  }
`;

export const CoverImage = styled(Image)`
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
